import classNames from 'classnames'
import {
  uswitchRichTextBlockStyles,
  confusedhRichTextBlockStyles,
  moneyRichTextBlockStyles,
} from '../../platinum-modules/single-column-rich-text/styles'
import React from 'react'
import { PlatinumBillboardProps } from '../types'

const PlatinumBillboard: React.FC<PlatinumBillboardProps> = ({
  breadcrumbs,
  primaryContent,
  primarySlot,
  fullWidthSlot,
  bgImage,
  showImageOnMobile,
  mobileImage,
  brand,
}) => {
  return (
    <div className='PlatinumBillboard'>
      {breadcrumbs && (
        <div className='PlatinumBillboard__breadcrumbs'>
          {React.cloneElement(breadcrumbs, { variant: 'billboard' })}
        </div>
      )}
      {mobileImage && (
        <div
          className='PlatinumBillboard__mobileImage'
          style={{ backgroundImage: `url(${mobileImage})` }}
        />
      )}
      {!bgImage && <div />}
      <div className='PlatinumBillboard__upperSlot'>
        <div
          className={classNames('PlatinumBillboard__upperSlot__primaryContent', {
            'PlatinumBillboard__upperSlot__primaryContent--fullWidth': !primarySlot,
          })}
        >
          {' '}
          {React.cloneElement(primaryContent, {
            style:
              brand === 'money'
                ? moneyRichTextBlockStyles
                : brand === 'confused'
                ? confusedhRichTextBlockStyles
                : uswitchRichTextBlockStyles,
          })}
        </div>
        {primarySlot && (
          <div className='PlatinumBillboard__upperSlot__primarySlot'>
            {React.cloneElement(primarySlot, { variant: 'billboard' })}
          </div>
        )}
        {!primarySlot && bgImage && (
          <>
            <div
              style={{
                backgroundImage: `url(${bgImage})`,
              }}
              className={classNames('PlatinumBillboard__upperSlot__primarySlotImage', {
                'PlatinumBillboard__upperSlot__primarySlotImage--hide':
                  mobileImage || !showImageOnMobile,
              })}
            />
          </>
        )}
      </div>
      {fullWidthSlot && (
        <div className='PlatinumBillboard__fullWidthSlot'>{React.cloneElement(fullWidthSlot)}</div>
      )}
    </div>
  )
}

export default PlatinumBillboard
